import { render, staticRenderFns } from "./BrandLogoTextboxSuperieur.vue?vue&type=template&id=b3535df0&"
import script from "./BrandLogoTextboxSuperieur.vue?vue&type=script&lang=js&"
export * from "./BrandLogoTextboxSuperieur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports